"use client";

import Image from "next/image";
import AnimatedSection from "../../AnimatedSection";
import { ENV } from "@/app/environment/environment";
import Link from "next/link";

export default function OurService() {
    return (
        <div className="max-w-6xl mx-auto px-4 py-12">
            <h2 className="text-3xl font-bold mb-8 text-center text-4xl">Nos Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                <AnimatedSection>
                    <div className="bg-white shadow rounded-lg p-6 h-full text-center">

                        <div className="relative w-[200px] h-[120px] mx-auto mb-4 mt-14">
                            <Image
                                src={`${ENV.bucket}/images/location-de-voiture.png`}
                                alt="Voiture avec chauffeur"
                                fill
                                className="object-contain"
                            />
                        </div>


                        <h3 className="text-2xl font-semibold mb-2 mt-9">Location de Voiture avec chauffeur privé</h3>
                        <p className="text-gray-700 mb-4">
                            Déplacez-vous en toute sérénité grâce à nos chauffeurs professionnels à l&rsquo;île Maurice.
                        </p>
                        <Link href={`/booking/car`} className="mt-4">
                            <button className="btn-xl">
                                Réserver maintenant
                            </button>
                        </Link>

                    </div>
                </AnimatedSection>

                <AnimatedSection>
                    <div className="bg-white shadow rounded-lg p-6 h-full text-center">


                        <Image
                            src={`${ENV.bucket}/images/cours-conduite.webp`}
                            alt="Voiture avec chauffeur"
                            width={200}
                            height={120} // ajuste selon ton image
                            className="mx-auto mb-4"
                            priority // optionnel : si c’est une image importante à charger vite
                        />


                        <h3 className="text-2xl font-semibold mb-2">Cours de conduite personnalisés</h3>
                        <p className="text-gray-700 mb-4">
                            Apprenez à conduire en toute confiance avec nos moniteurs qualifiés.
                        </p>
                        <button className="btn-xl">
                            Réserver un cours
                        </button>
                    </div>
                </AnimatedSection>

            </div>
        </div>
    )
}